!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/RestrictedInput")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/RestrictedInput"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/RestrictedInput")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return a = {}, o.m = i = {
    0: function (e, t) {
      e.exports = r;
    },
    2: function (e, t, o) {
      "use strict";

      var r,
        n,
        u = function () {
          return r = void 0 === r ? !(!(window && document && document.all) || window.atob) : r;
        },
        i = (n = {}, function (e) {
          if (void 0 === n[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            n[e] = t;
          }
          return n[e];
        }),
        s = [];
      function l(e) {
        for (var t = -1, r = 0; r < s.length; r++) if (s[r].identifier === e) {
          t = r;
          break;
        }
        return t;
      }
      function c(e, t) {
        for (var r = {}, n = [], o = 0; o < e.length; o++) {
          var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            u = r[a] || 0,
            c = "".concat(a, " ").concat(u);
          r[a] = u + 1;
          u = l(c), i = {
            css: i[1],
            media: i[2],
            sourceMap: i[3]
          };
          -1 !== u ? (s[u].references++, s[u].updater(i)) : s.push({
            identifier: c,
            updater: function (t, e) {
              var r, n, o;
              {
                var i;
                o = e.singleton ? (i = m++, r = h = h || p(e), n = d.bind(null, r, i, !1), d.bind(null, r, i, !0)) : (r = p(e), n = function (e, t, r) {
                  var n = r.css,
                    o = r.media,
                    r = r.sourceMap;
                  o ? e.setAttribute("media", o) : e.removeAttribute("media");
                  r && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = n;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(n));
                  }
                }.bind(null, r, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(r);
                });
              }
              return n(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || n(t = e) : o();
              };
            }(i, t),
            references: 1
          }), n.push(c);
        }
        return n;
      }
      function p(e) {
        var t,
          r = document.createElement("style"),
          n = e.attributes || {};
        if (void 0 !== n.nonce || (t = o.nc) && (n.nonce = t), Object.keys(n).forEach(function (e) {
          r.setAttribute(e, n[e]);
        }), "function" == typeof e.insert) e.insert(r);else {
          e = i(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(r);
        }
        return r;
      }
      var a,
        f = (a = [], function (e, t) {
          return a[e] = t, a.filter(Boolean).join("\n");
        });
      function d(e, t, r, n) {
        r = r ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
        e.styleSheet ? e.styleSheet.cssText = f(t, r) : (n = document.createTextNode(r), (r = e.childNodes)[t] && e.removeChild(r[t]), r.length ? e.insertBefore(n, r[t]) : e.appendChild(n));
      }
      var h = null,
        m = 0;
      e.exports = function (e, i) {
        (i = i || {}).singleton || "boolean" == typeof i.singleton || (i.singleton = u());
        var a = c(e = e || [], i);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < a.length; t++) {
              var r = l(a[t]);
              s[r].references--;
            }
            for (var e = c(e, i), n = 0; n < a.length; n++) {
              var o = l(a[n]);
              0 === s[o].references && (s[o].updater(), s.splice(o, 1));
            }
            a = e;
          }
        };
      };
    },
    309: function (e, t, r) {
      (t = e.exports = r(4)()).push([e.i, "._1Bmuz-2-0-721{font-family:Verdana,DejaVu Sans;font-size:12px;font-weight:400;color:#000;height:36px}._3k6iY-2-0-721,._3T7zA-2-0-721{border-radius:2px;background-color:#fff;border:1px solid #ccc;width:50px;padding:0 5px;box-sizing:border-box;color:#39444f;outline:0}._3k6iY-2-0-721{margin-left:9px}._3T7zA-2-0-721{border-left:0;margin-right:9px}", ""]), t.locals = {
        "from-to-filter": "_1Bmuz-2-0-721",
        "from-field": "_3k6iY-2-0-721",
        "to-field": "_3T7zA-2-0-721"
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var a = [];
        return a.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var r = this[t];
            r[2] ? e.push("@media " + r[2] + "{" + r[1] + "}") : e.push(r[1]);
          }
          return e.join("");
        }, a.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var r = {}, n = 0; n < this.length; n++) {
            var o = this[n][0];
            "number" == typeof o && (r[o] = !0);
          }
          for (n = 0; n < e.length; n++) {
            var i = e[n];
            "number" == typeof i[0] && r[i[0]] || (t && !i[2] ? i[2] = t : t && (i[2] = "(" + i[2] + ") and (" + t + ")"), a.push(i));
          }
        }, a;
      };
    },
    40: function (e, t) {
      e.exports = n;
    },
    552: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return g;
      });
      var n = r(0),
        a = r.n(n),
        o = r(40),
        u = r.n(o),
        i = r(7),
        t = r(2),
        o = r.n(t),
        t = r(309),
        r = r.n(t),
        t = {
          insert: "head",
          singleton: !1
        },
        c = (o()(r.a, t), r.a.locals || {});
      function s(t, e) {
        var r,
          n = Object.keys(t);
        return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(t), e && (r = r.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), n.push.apply(n, r)), n;
      }
      function l(n) {
        for (var e = 1; e < arguments.length; e++) {
          var o = null != arguments[e] ? arguments[e] : {};
          e % 2 ? s(Object(o), !0).forEach(function (e) {
            var t, r;
            t = n, e = o[r = e], r in t ? Object.defineProperty(t, r, {
              value: e,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : t[r] = e;
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o)) : s(Object(o)).forEach(function (e) {
            Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(o, e));
          });
        }
        return n;
      }
      var r = {
          from: "от",
          to: "до"
        },
        p = {
          ru: r,
          en: l(l({}, r), {
            from: "from",
            to: "to"
          })
        };
      function f(e) {
        return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function d() {
        return (d = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r,
              n = arguments[t];
            for (r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      function h(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }
      function m(e, t) {
        return (m = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function b(r) {
        var n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }();
        return function () {
          var e,
            t = y(r);
          return e = n ? (e = y(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments), t = this, !(e = e) || "object" !== f(e) && "function" != typeof e ? function (e) {
            if (void 0 !== e) return e;
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }(t) : e;
        };
      }
      function y(e) {
        return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      var g = function () {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && m(e, t);
        }(i, n["PureComponent"]);
        var e,
          t,
          r,
          o = b(i);
        function i(e) {
          var n;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (n = o.call(this, e)).handleChange = function (r) {
            return function (e, t) {
              return n.props.onChange && n.props.onChange(r, t);
            };
          }, n.handleBlur = function (t) {
            return function (e) {
              n.props.viceVersa && n.props.onChange && n.props.fromValue && n.props.toValue && parseFloat(n.props.fromValue) > parseFloat(n.props.toValue) && (n.props.onChange("fromValue", n.props.toValue), n.props.onChange("toValue", n.props.fromValue)), "function" == typeof n.props.fromOnBlur && "fromValue" === t ? n.props.fromOnBlur(e) : "function" == typeof n.props.fromOnBlur && "toValue" === t && n.props.toOnBlur(e);
            };
          }, n.strings = p[e.locale] || p.ru, n;
        }
        return e = i, (t = [{
          key: "render",
          value: function () {
            return a.a.createElement("div", {
              className: c["from-to-filter"]
            }, this.props.label, a.a.createElement(u.a, d({
              className: c["from-field"],
              clearZeroOnBlur: this.props.clearZeroOnBlur,
              inputRestriction: this.props.inputRestriction,
              maxLength: this.props.maxLength,
              onChange: this.handleChange("fromValue"),
              placeholder: this.strings.from,
              type: "text",
              value: this.props.fromValue,
              maxDecimalPlaces: this.props.maxDecimalPlaces,
              onBlur: this.handleBlur("fromValue")
            }, this.props.inputPropsFrom)), a.a.createElement(u.a, d({
              className: c["to-field"],
              clearZeroOnBlur: this.props.clearZeroOnBlur,
              inputRestriction: this.props.inputRestriction,
              maxLength: this.props.maxLength,
              onChange: this.handleChange("toValue"),
              placeholder: this.strings.to,
              type: "text",
              value: this.props.toValue,
              maxDecimalPlaces: this.props.maxDecimalPlaces,
              onBlur: this.handleBlur("toValue")
            }, this.props.inputPropsTo)), this.props.measure);
          }
        }]) && h(e.prototype, t), r && h(e, r), i;
      }();
      g.defaultProps = {
        inputRestriction: i.inputRestriction.nonNegativeFloat,
        maxLength: 4,
        maxDecimalPlaces: 3,
        clearZeroOnBlur: !0
      };
    },
    7: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "errorPositions", function () {
        return n;
      }), r.d(t, "inputRestriction", function () {
        return o;
      }), r.d(t, "residences", function () {
        return i;
      }), r.d(t, "currencies", function () {
        return a;
      }), r.d(t, "individualOwnerships", function () {
        return u;
      }), r.d(t, "personalOwnerships", function () {
        return c;
      }), r.d(t, "individualOwnershipIds", function () {
        return s;
      }), r.d(t, "personalOwnershipIds", function () {
        return l;
      }), r.d(t, "requisiteTypeIds", function () {
        return p;
      }), r.d(t, "allContactsSelected", function () {
        return f;
      }), r.d(t, "commonBoardId", function () {
        return d;
      });
      var n = {
          bottom: "bottom",
          custom: "custom",
          right: "right",
          bottomRightAligned: "bottomRightAligned"
        },
        o = {
          none: 0,
          numbersOnly: 1,
          nonNegativeFloat: 2,
          phoneNumber: 3,
          zeroTo9999Float: 4,
          zeroTo99Float: 5,
          percents: 6,
          zeroTo99: 7,
          numbersWithSlash: 8,
          nonNegativeFloatDecimalLimit: 9
        },
        i = {
          russia: 0,
          ukraine: 1,
          kazakhstan: 2,
          other: 3,
          belorussia: 4,
          foreign: 5
        },
        a = {
          1: i.russia,
          2: i.other,
          3: i.other,
          5: i.ukraine,
          21: i.kazakhstan,
          22: i.belorussia
        },
        u = {
          IP: 4,
          PBOYUL: 7,
          PBOYUL2: 12,
          headOfFarm: 27,
          privateManufacturingEnterprise1: 39,
          privateManufacturingEnterprise2: 41
        },
        c = {
          personal: 25,
          personalEnterpreneur: 22
        },
        s = [4, 7, 12, 24, 27, 39, 40, 41],
        l = [25, 22, 76],
        p = {
          company: 1,
          individual: 6,
          natural: 3
        },
        f = "all_contacts",
        d = "a0a0a0a0a0a0a0a0a0a0a0a0";
    }
  }, o.c = a, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 552);
  function o(e) {
    if (a[e]) return a[e].exports;
    var t = a[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, a;
});